<template>
    <!--    Contacts    -->
    <div class="contacts">
        <div class="contacts__heading d-flex">

            <svg width="780" height="112" viewBox="0 0 780 112" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M89.5762 73.8549C88.721 85.6887 84.344 95.0047 76.4454 101.803C68.5971 108.601 58.2334 112 45.3541 112C31.2674 112 20.1741 107.266 12.0743 97.7995C4.02477 88.2821 0 75.2398 0 58.6725V51.9499C0 41.375 1.86146 32.059 5.58437 24.002C9.30728 15.945 14.6149 9.77629 21.5074 5.49599C28.4501 1.16533 36.4996 -1 45.656 -1C58.334 -1 68.5468 2.39906 76.2945 9.19719C84.0422 15.9953 88.5197 25.5379 89.7272 37.8249H67.0878C66.5344 30.7246 64.5472 25.5882 61.1262 22.4158C57.7554 19.193 52.5987 17.5816 45.656 17.5816C38.1095 17.5816 32.4497 20.3008 28.6765 25.7393C24.9536 31.1275 23.0418 39.5118 22.9412 50.8924V59.2012C22.9412 71.0853 24.7272 79.7718 28.2991 85.2607C31.9214 90.7496 37.6064 93.494 45.3541 93.494C52.3471 93.494 57.5542 91.9078 60.9752 88.7353C64.4466 85.5125 66.4338 80.5524 66.9369 73.8549H89.5762Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path
                    d="M194.698 57.9926C194.698 68.8193 192.786 78.3115 188.963 86.4693C185.139 94.627 179.656 100.922 172.512 105.353C165.418 109.784 157.268 112 148.061 112C138.955 112 130.83 109.809 123.686 105.428C116.542 101.047 111.008 94.8033 107.084 86.6959C103.16 78.5381 101.173 69.1718 101.122 58.5969V53.1584C101.122 42.3318 103.059 32.8144 106.933 24.6063C110.857 16.3478 116.366 10.0281 123.46 5.64706C130.604 1.21569 138.754 -1 147.91 -1C157.067 -1 165.192 1.21569 172.285 5.64706C179.429 10.0281 184.938 16.3478 188.812 24.6063C192.736 32.8144 194.698 42.3066 194.698 53.0829V57.9926ZM171.757 53.0074C171.757 41.4757 169.694 32.7137 165.569 26.7213C161.443 20.7288 155.557 17.7326 147.91 17.7326C140.313 17.7326 134.452 20.7037 130.327 26.6457C126.202 32.5374 124.114 41.1988 124.063 52.6297V57.9926C124.063 69.2222 126.126 77.9338 130.252 84.1277C134.377 90.3215 140.313 93.4184 148.061 93.4184C155.658 93.4184 161.494 90.4474 165.569 84.5053C169.644 78.5129 171.707 69.8012 171.757 58.3703V53.0074Z"
                    fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M300.499 110.489H277.86L233.789 38.127V110.489H211.149V0.510695H233.789L277.935 73.0241V0.510695H300.499V110.489Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M400.716 18.8656H367.059V110.489H344.419V18.8656H311.215V0.510695H400.716V18.8656Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M466.672 87.8289H426.978L419.431 110.489H395.358L436.26 0.510695H457.239L498.367 110.489H474.294L466.672 87.8289ZM433.09 69.4739H460.559L446.749 28.3075L433.09 69.4739Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M593.226 73.8549C592.37 85.6887 587.993 95.0047 580.095 101.803C572.247 108.601 561.883 112 549.003 112C534.917 112 523.824 107.266 515.724 97.7995C507.674 88.2821 503.649 75.2398 503.649 58.6725V51.9499C503.649 41.375 505.511 32.059 509.234 24.002C512.957 15.945 518.264 9.77629 525.157 5.49599C532.099 1.16533 540.149 -1 549.305 -1C561.983 -1 572.196 2.39906 579.944 9.19719C587.692 15.9953 592.169 25.5379 593.377 37.8249H570.737C570.184 30.7246 568.197 25.5882 564.776 22.4158C561.405 19.193 556.248 17.5816 549.305 17.5816C541.759 17.5816 536.099 20.3008 532.326 25.7393C528.603 31.1275 526.691 39.5118 526.591 50.8924V59.2012C526.591 71.0853 528.377 79.7718 531.949 85.2607C535.571 90.7496 541.256 93.494 549.003 93.494C555.997 93.494 561.204 91.9078 564.625 88.7353C568.096 85.5125 570.083 80.5524 570.586 73.8549H593.226Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M688.537 18.8656H654.88V110.489H632.241V18.8656H599.036V0.510695H688.537V18.8656Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path
                    d="M757.285 81.635C757.285 77.3547 755.776 74.0816 752.757 71.8155C749.739 69.4991 744.305 67.082 736.457 64.5642C728.609 61.996 722.396 59.4782 717.817 57.0107C705.341 50.2629 699.102 41.1736 699.102 29.7426C699.102 23.8006 700.762 18.5131 704.083 13.8803C707.454 9.19719 712.258 5.54635 718.497 2.92781C724.785 0.309269 731.829 -1 739.627 -1C747.475 -1 754.468 0.43516 760.606 3.30548C766.743 6.12545 771.498 10.1288 774.868 15.3155C778.289 20.5022 780 26.3939 780 32.9906H757.361C757.361 27.955 755.776 24.0524 752.606 21.2828C749.437 18.4628 744.984 17.0528 739.249 17.0528C733.715 17.0528 729.414 18.2362 726.345 20.6029C723.276 22.9193 721.741 25.9911 721.741 29.8182C721.741 33.3935 723.527 36.3897 727.099 38.8068C730.722 41.2239 736.029 43.49 743.022 45.6049C755.902 49.4824 765.284 54.2914 771.171 60.0321C777.057 65.7727 780 72.9234 780 81.484C780 91.0013 776.403 98.4793 769.209 103.918C762.014 109.306 752.33 112 740.155 112C731.703 112 724.005 110.464 717.063 107.392C710.12 104.27 704.812 100.015 701.14 94.627C697.517 89.2389 695.706 82.9947 695.706 75.8944H718.421C718.421 88.0303 725.666 94.0983 740.155 94.0983C745.538 94.0983 749.739 93.0156 752.757 90.8503C755.776 88.6346 757.285 85.5628 757.285 81.635Z"
                    fill="#F0F5FD" fill-opacity="0.1"/>
            </svg>

            <div class="contacts__heading-title">
                Связаться с нами
            </div>
        </div>

        <div class="contacts__content">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <form action="#" class="contacts__form" @submit.prevent="sendContactForm">
                            <div class="contacts__legend">Есть вопросы и предложения?</div>
                            <fieldset class="contacts__fieldset">
                                <label for="contacts-name" class="contacts__label">Имя</label>
                                <input type="text" class="contacts__input" id="contacts-name" placeholder="Введите ваше имя" v-model="$v.contactForm.name.$model">
                                <span class="text-danger" v-if="$v.contactForm.$dirty && !$v.contactForm.name.required">Поле обязательно для заполнения</span>
                                <span class="text-danger" v-if="$v.contactForm.$dirty && !$v.contactForm.name.maxLength">Максимальное количество символов: 200</span>
                            </fieldset>
                            <fieldset class="contacts__fieldset">
                                <label for="contacts-phone" class="contacts__label">Номер телефона</label>
                                <input type="tel" @keypress="isNumber($event)" class="contacts__input" id="contacts-phone" placeholder="Введите ваш номер телефона" v-model="$v.contactForm.phone.$model">
                                <span class="text-danger" v-if="$v.contactForm.$dirty && !$v.contactForm.phone.maxLength">Максимальное количество символов: 20</span>
                            </fieldset>
                            <fieldset class="contacts__fieldset">
                                <label for="contacts-email" class="contacts__label">Email</label>
                                <input type="email" class="contacts__input" id="contacts-email" placeholder="Введите ваш email" v-model="$v.contactForm.email.$model">
                                <span class="text-danger" v-if="$v.contactForm.$dirty && !$v.contactForm.email.required">Поле обязательно для заполнения</span>
                                <span class="text-danger" v-if="$v.contactForm.$dirty && !$v.contactForm.email.maxLength">Максимальное количество символов: 200</span>
                            </fieldset>
                            <fieldset class="contacts__fieldset">
                                <label for="contacts-comment" class="contacts__label">Сообщение</label>
                                <textarea rows="3" class="contacts__input contacts__input-textarea" id="contacts-comment" placeholder="Введите текстовое сообщение" v-model="$v.contactForm.message.$model"></textarea>
                                <span class="text-danger" v-if="$v.contactForm.$dirty && !$v.contactForm.message.required">Поле обязательно для заполнения</span>
                                <span class="text-danger" v-if="$v.contactForm.$dirty && !$v.contactForm.message.maxLength">Максимальное количество символов: 1000</span>
                            </fieldset>
                            <fieldset class="contacts__fieldset contacts__fieldset-actions">
                                <input type="submit" class="btn btn--md btn--round" :class="{'message-was-sent': sendStatus === 'success'}" :value="contactFormBtnText">
                            </fieldset>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--    Contacts    -->
</template>

<script>
import {required, email, maxLength} from 'vuelidate/lib/validators'

export default {
    name: "Contacts",
    data() {
        return {
            sendStatus: 'wait',
            contactForm: {
                name: '',
                phone: '',
                email: '',
                message: ''
            }
        }
    },
    computed: {
        contactFormBtnText() {
            return this.sendStatus === 'wait' ? 'Отправить' : (this.sendStatus === 'sending' ? 'Отправляется...' : (this.sendStatus === 'error' ? 'Произошла ошибка! Попробуйте еще раз!' : 'Спасибо! Ваше сообщение отправлено!'));
        }
    },
    methods: {
        isNumber: function (evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 43) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        sendContactForm() {
            let self = this;
            self.$v.contactForm.$touch();
            if (self.$v.contactForm.$error) {
                return false;
            }
            self.sendStatus = 'sending';
            axios.post('/api/contact-form/store', self.contactForm).then(function () {
                self.sendStatus = 'success';
                self.contactForm = {
                    name: '',
                    phone: '',
                    email: '',
                    message: ''
                };

                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    event: 'contact_us'
                })

            }).catch(function () {
                self.sendStatus = 'error';
            }).then(function () {
                self.$v.contactForm.$reset();
                setTimeout(function () {
                    self.sendStatus = 'wait';
                }, 5000);
            });
        }
    },
    validations: {
        contactForm: {
            name: {required, maxLength: maxLength(250)},
            phone: {maxLength: maxLength(20)},
            email: {required, email, maxLength: maxLength(250)},
            message: {required, maxLength: maxLength(1000)}
        }
    }
}
</script>

<style lang="scss" scoped>
// Contacts
.contacts {
    background: #F0F1F5;

    &__heading {
        position: relative;
        background: radial-gradient(100% 2844.44% at 0% 50%, #2E76E4 0%, #6C4DBB 100%);
        padding: 0 10px;
        font-weight: bold;
        font-size: 40px;
        line-height: 48px;
        color: #FFFFFF;
        justify-content: center;

        &-title {
            position: absolute;
            left: 0;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            text-align: center;
        }

        svg {
            width: 100%;
        }
    }

    &__content {
        padding: 25px 0;
    }

    &__form {
        padding: 20px 53px;
        margin: 0 auto;
        width: 100%;
        max-width: 510px;
        background: #FFFFFF;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        color: #333333;
    }

    &__legend {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 24px;
    }

    &__fieldset {
        margin-top: 15px;

        &-actions {
            margin-top: 25px;
            text-align: center;
        }
    }

    &__label {
        font-size: 14px;
        line-height: 22px;
        color: #555555;
        //margin-left: 20px;
        margin-bottom: 5px;
    }

    &__input {
        background: #FFFFFF;
        border: 1px solid #CED4DA;
        border-radius: 3px;
        font-size: 14px;
        line-height: 22px;
        color: #333;
        padding: 9px 20px;
        height: auto;
        min-height: auto;

        &::placeholder {
            color: #929292;
        }

        &-textarea {
            resize: none;
        }
    }

    .btn {
        font-weight: bold;
        font-size: 14px;
        line-height: 26px;
        padding: 10px 20px;
    }

    .btn.message-was-sent {
        background: green;
    }
}

@media screen and (max-width: 768px) {
    .contacts__heading {
        font-size: 26px;
        line-height: 36px;
    }
    .contacts__legend {
        font-size: 18px;
        line-height: 26px;
    }
    .contacts__form {
        padding: 20px 30px;
    }
}

@media screen and (max-width: 500px) {
    .contacts__legend {
        text-align: center;
    }
}

// Contacts
</style>
